import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AbpHttpInterceptor } from 'abp-ng2-module';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.ConfigurationServiceProxy,
        ApiServiceProxies.CountryServiceProxy,
        ApiServiceProxies.CityServiceProxy,
        ApiServiceProxies.IndustryServiceProxy,
        ApiServiceProxies.PackageServiceProxy,
        ApiServiceProxies.SkillServiceProxy,
        ApiServiceProxies.JobPositionServiceProxy,
        ApiServiceProxies.AdvertisementServiceProxy,
        ApiServiceProxies.CompanyAdminServiceProxy,
        ApiServiceProxies.CompanyPackageAdminServiceProxy,
        ApiServiceProxies.JobAdminServiceProxy,
        ApiServiceProxies.AboutUsServiceProxy,
        ApiServiceProxies.ContactInfoServiceProxy,
        ApiServiceProxies.HomeSliderServiceProxy,
        ApiServiceProxies.EmployeeAdminServiceProxy,
        ApiServiceProxies.AffiliateApplicantServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.SettingServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true },
    ],
})
export class ServiceProxyModule {}
